import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { CampaignRoutingTargetState } from "@signalist/shared-types";

import { classNames } from "@/utils/classNames";

import { targetPillOf } from "./utils/campaignRoutingTargets";

/** A campaign's state as a routing target: Active, Ready, Paused, Ended, Invalid or Deleted. */
export const RoutingTargetPill: FunctionComponent<{ state: CampaignRoutingTargetState }> = ({
	state,
}) => {
	const { t } = useTranslation();
	const pill = targetPillOf(state);

	return (
		<span
			className={classNames(
				"whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium",
				pill.className
			)}
			data-testid={`routing-target-${state}`}
		>
			{t(pill.labelKey)}
		</span>
	);
};
